import React, { Component } from 'react'
import omit from 'lodash/omit'
import forOwn from 'lodash/forOwn'
import { parseQuery } from '../helpers/queryHelper'

export interface RenderProps {
  location: Location
}

export interface Props {
  renderProps: RenderProps
}

export default class FilterBadge extends Component<Props> {
  countFilters = (query, defaultFilters) => {
    let count = 0

    forOwn(omit(query, defaultFilters), (obj: object[] | object) => {
      if (Array.isArray(obj)) {
        count += obj.length
      } else {
        count += 1
      }
    })

    return count
  }

  renderBadge = (count) => {
    if (count > 0 && count < 10) {
      return <span className="index-table__filter-badge">{count}</span>
    } else if (count >= 10) {
      return (
        <span className="index-table__filter-badge index-table__filter-badge--multi">
          {count}
        </span>
      )
    } else {
      return <span className="index-table__filter-icon icon-filters" />
    }
  }

  render() {
    const {
      location: { search },
    } = this.props.renderProps
    const parsedQuery = parseQuery(search)
    const defaultFilters = ['offset', 'limit']
    const count = this.countFilters(parsedQuery, defaultFilters)
    return <div>{this.renderBadge(count)}</div>
  }
}
